import { ProducerActionType } from '../../actions/ActionType'

const initialState = {
    loading: false,
    objeckt:[]
}

type action = {
    type: string
    objeckt?: any
}

const ProducerReducer = (state = initialState, action: action) => {
    switch (action.type) {
        case ProducerActionType.Producer_INIT:
            return {
                ...state,
                objeckt:action.objeckt,
                loading: true
            }
        default:
            return state
    }
}

export default ProducerReducer
